module.exports = __webpack_public_path__ + "static/media/home_bg2.57035d05.png";